import React from 'react';
import { DateTime } from 'luxon';
import { useSirenEntity, useSirenActionFields, useSirenActionSubmitter } from '~/utility/BinSentry-ui-utility';
import { Button, CircularProgress, Tooltip, Icons } from '~/lib/bn-material-ui';

export function OrderSyncToFmmButton({ orderHref, orderEntity, className, size }) {
  const actionConfig = useOrderSyncToFmmAction({ orderHref, orderEntity });

  if (!actionConfig) {
    return null;
  }

  const { isQueued, isSubmitting, submit, tooltipTitle } = actionConfig;

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        className={className}
        disabled={isSubmitting}
        size={size}
        startIcon={<FmmSyncStatusIcon isSubmitting={isSubmitting} isQueued={isQueued} />}
        variant='outlined'
        onClick={submit}
      >
        FMM
      </Button>
    </Tooltip>
  );
}
export function FmmSyncStatusIcon({ isSubmitting, isQueued }) {
  if (isSubmitting) {
    return <CircularProgress size={16} thickness={4} />;
  }

  return isQueued ? <Icons.CheckBox /> : <Icons.CheckBoxOutlineBlankOutlined />;
}

export function useOrderSyncToFmmAction({ orderHref, orderEntity: orderEntityProp }) {
  const { entity: orderEntityFromHref } = useSirenEntity({ href: orderHref });
  const orderEntity = orderEntityProp || orderEntityFromHref;
  const integrationsHref = orderEntity?.getLinkByRel('https://api.binsentry.com/rel/integrations')?.href;
  const { entity: integrationsEntity } = useSirenEntity({ href: integrationsHref });
  const fmmHref = integrationsEntity?.getSubEntityByRel('https://api.binsentry.com/rel/fmm-integration')?.href;
  const { entity: fmmEntity } = useSirenEntity({ href: fmmHref });
  const { fields, sirenAction } = useSirenActionFields({ entity: fmmEntity, actionName: 'queue-order' });
  const { submit, submitting } = useSirenActionSubmitter({ sirenAction, fields: fields || {} });

  const isQueued = fmmEntity?.properties.queuedAtIsoDate;
  const queueAction = fmmEntity?.getAction('queue-order');

  if (!queueAction) {
    return null;
  }

  const tooltipTitle = isQueued ?
    `Last Synchronize on ${DateTime.fromISO(fmmEntity?.properties.queuedAtIsoDate).toFormat('LLL dd, yyyy')}` :
    'Synchronize to Feed Mill Manager';

  return {
    isQueued,
    isSubmitting: submitting,
    fmmEntity,
    submit: () => {
      if (isQueued) {
        const confirmed = window.confirm('This Order has already been queued. If this Order has not been deleted from FMM conflicts may occur.');
        if (!confirmed) {
          return;
        }
      }

      submit();
    },
    tooltipTitle,
  };
}
